import styled, { css } from "styled-components";

import { FontWeightType } from "@sso/types";

interface TypographyProps {
  display?: "flex" | "initial" | "none" | "block";
  textTransform?: "capitalize" | "lowercase" | "uppercase";
  color?: string;
  size?: string;
  margin?: string;
  padding?: string;
  disabled?: boolean;
  overflowEllipsis?: boolean;
  width?: string;
  cursorPointer?: boolean;
  textAlign?: "center" | "right" | "left" | "inherit" | "initial";
  fontWeight?: FontWeightType;
  lineHeight?: number;
  letterSpacing?: string;
  userSelect?: "none" | "all" | "auto";
  fontFamily?: string;
  whiteSpace?: string;
}

export const Typography = styled.span<TypographyProps>`
  display: ${p => p.display || "flex"};
  text-align: ${p => p.textAlign || "center"};
  user-select: ${p => p.userSelect || "none"};
  font-family: ${p => p.fontFamily || `Roboto , sans-serif`};
  color: ${p => p.color || p.theme.colors.text.primary};
  white-space: pre-line;
  ${p => p.textTransform && `text-transform:${p.textTransform};`};
  ${p => p.size && `font-size:${p.size};`}
  ${p => p.margin && `margin:${p.margin};`}
  ${p => p.padding && `padding:${p.padding};`}
  ${p => p.fontWeight && `font-weight:${p.fontWeight};`}
  ${p => p.disabled && `opacity:${p.theme.colors.action.disabledOpacity};`}
  ${p => p.cursorPointer && "cursor: pointer"};
  ${p => p.lineHeight && `line-height:${p.lineHeight};`}
  ${p => p.letterSpacing && `letter-spacing:${p.letterSpacing};`}
  ${p => p.width && `width:${p.width};`}
  ${p => p.whiteSpace && `white-space:${p.whiteSpace};`}
  ${p =>
    p.overflowEllipsis &&
    css`
      display: block;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    `}
`;
